export const tr = {
    'loading-text': 'Yükleniyor...'
};
